import { Pipe, PipeTransform } from '@angular/core';
import { CatalogData } from '../providers/catalog';

@Pipe({
  name: 'productData'
})

export class ProductDataPipe implements PipeTransform {

  constructor(
    private catalogProvider: CatalogData
  ) { }

  transform(value: string, clientId: string): any {
    return this.catalogProvider.getCatalogById(clientId, value);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/product-data.pipe.ts